import { useMutation } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import type { ManualProcessOutcome } from "@/types/domain";

/**
 * Reintenta la extracción de una relación de precios que falló (acción de admin):
 * mismo archivo, modelo bueno y sin el tope de páginas. Con `mode: "budget"` lo
 * lee como presupuesto de obra. Devuelve cómo terminó para pintarlo en la columna
 * de resultado.
 */
export function useRetryExtraction() {
  return useMutation({
    mutationFn: ({
      fileId,
      mode,
    }: {
      fileId: number;
      mode?: "budget";
    }) =>
      fetchToBackend<ManualProcessOutcome>(
        "/admin/contractings/retry-extraction",
        {
          method: "POST",
          body: JSON.stringify({ contractingfile_id: fileId, mode }),
        },
      ),
  });
}
